import React from 'react';
import ImageUploader from '../../features/media/uploaders/ImageUploader';
import CourseImageWrapper from './CourseImageWrapper';
import CourseCardWrapper from './CourseCardWrapper';
import CourseInfoWrapper from './CourseInfoWrapper';
import Flex from '../Flex';
import Figure from '../Figure';
import SimpleButton from '../molecules/Button/SimpleButton';
import { useTranslation } from 'react-i18next';

const CourseCardEdit = ({ saveImage, onSaveInfo, course, label }) => {
  const { t } = useTranslation();

  return (
    <Flex width='50%' justify='center' breakPoint={{ size: 'tablet', value: 'width:100%;' }}>
      <CourseCardWrapper>
        <CourseImageWrapper>
          <ImageUploader type={'single'} id={'courseEdit'} saveAction={saveImage} imageToPreview={course?.coverImage?.url} label={label} iconName='Add'>
            {course?.coverImage?.url && (
              <Figure.Rectangle>
                <img alt={'imageToPreview'} src={course?.coverImage?.url} loading='lazy' />
              </Figure.Rectangle>
            )}
          </ImageUploader>
        </CourseImageWrapper>
        <CourseInfoWrapper course={course} showProgress={true} saveCourseInfo={onSaveInfo} ownerName={course?.ownerName} ownerColor={course?.theme?.color}>
          <SimpleButton startIcon='Student' variant='secondary' fullWidth='true'>
            {t('globals.continueCourse')}
          </SimpleButton>
        </CourseInfoWrapper>
      </CourseCardWrapper>
    </Flex>
  );
};

export default CourseCardEdit;
